import { ONBOARDING_SCAN_KEY } from "../actions/onboardingActions";

/** Persisted reducer snapshot for mid-flow refresh / resume. */
export const ONBOARDING_FLOW_STATE_KEY = "onboardingFlowState";

/** True while the user is mid post-login onboarding (questionnaire / assessment). */
export const isOnboardingScan = () =>
  typeof sessionStorage !== "undefined" &&
  sessionStorage.getItem(ONBOARDING_SCAN_KEY) === "1";

export const setOnboardingScan = () => {
  sessionStorage.setItem(ONBOARDING_SCAN_KEY, "1");
};

/** Clears mid-onboarding markers. Safe to call when keys are already absent. */
export const clearOnboardingSession = () => {
  try {
    sessionStorage.removeItem(ONBOARDING_SCAN_KEY);
    sessionStorage.removeItem(ONBOARDING_FLOW_STATE_KEY);
  } catch (_) {
    // Ignore storage failures (private mode, etc.)
  }
};

export { ONBOARDING_SCAN_KEY };
